/** 목록 끝 '더 보기' 줄 — useRenderLimit 와 함께 쓴다. 남은 줄이 없으면 그리지 않음. */
export function ShowMoreRow({ hidden, colSpan, onMore, onAll }: {
  hidden: number; colSpan: number; onMore: () => void; onAll: () => void
}) {
  if (hidden <= 0) return null
  return (
    <tr className="border-t border-slate-100">
      <td colSpan={colSpan} className="px-3 py-2 text-center text-xs text-slate-500">
        {hidden.toLocaleString()}줄 더 있음 ·{' '}
        <button type="button" onClick={onMore} className="text-blue-600 hover:underline font-semibold">더 보기</button>
        {' · '}
        <button type="button" onClick={onAll} className="text-blue-600 hover:underline">모두 보기</button>
        <span className="text-slate-400"> (검색하면 바로 찾을 수 있어요)</span>
      </td>
    </tr>
  )
}
